import React from "react";
import { Menu } from "lucide-react";
import logo from "@/assets/icons/logo.png";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

const navLinks = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Our Services" },
  { href: "#values", label: "Why Choose Us" },
  { href: "#work", label: "Our Work" },
  { href: "#contact", label: "Contact Us" },
];

const NavLink = ({ href, label, className, onClick }) => (
  <a
    href={href}
    onClick={onClick}
    className={cn(
      "font-heading text-base font-semibold text-primary-500 transition-colors hover:text-primary-500/80 hover:underline underline-offset-4 decoration-2",
      className
    )}
  >
    {label}
  </a>
);

const SiteNavbar = () => {
  const [open, setOpen] = React.useState(false);

  const closeSheet = () => setOpen(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/60 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-10">
        <a href="#home" className="flex items-center">
          <img src={logo} className="h-10" alt="Heyphord Logo" />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <NavLink key={link.href} {...link} />
          ))}
        </nav>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" aria-label="Open menu">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[280px]">
            <SheetHeader>
              <SheetTitle className="font-heading text-primary-500">
                Menu
              </SheetTitle>
            </SheetHeader>
            <nav className="mt-8 flex flex-col gap-6">
              {navLinks.map((link) => (
                <NavLink
                  key={link.href}
                  {...link}
                  onClick={closeSheet}
                  className="text-lg"
                />
              ))}
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default SiteNavbar;
